import {
  Feedback,
  HelpOutline,
  Dashboard,
  Home,
  AddToQueue,
  People as PeopleIcon,
  QuestionAnswer as QuestionAnswerIcon,
} from "@material-ui/icons"
import HomeWorkIcon from "@material-ui/icons/HomeWork"
import LocalAtmIcon from "@material-ui/icons/LocalAtm"
import HistoryOutlined from "@material-ui/icons/HistoryOutlined"
import GetApp from "@material-ui/icons/GetApp"
import ContactMailIcon from "@material-ui/icons/ContactMail"

export const getSuperAdminSections = () => [
  {
    id: "superadmin",
    items: [
      {
        id: "dashboard",
        title: "Dashboard",
        icon: Dashboard,
        href: "/superAdmin/dashboard",
      },
      {
        id: "conjuntos",
        title: "Conjuntos",
        icon: Home,
        href: "/superAdmin/conjuntos",
      },
      {
        id: "empresas",
        title: "Empresas",
        icon: HomeWorkIcon,
        href: "/superAdmin/Company",
      },
      {
        id: "usertglabs",
        title: "TGLabs Usuarios",
        icon: ContactMailIcon,
        href: "/superAdmin/usertglabs",
      },
      {
        id: "administradores",
        title: "Administradores",
        icon: PeopleIcon,
        href: "/superAdmin/administradores",
      },
      {
        id: "splash",
        title: "Splash",
        icon: AddToQueue,
        href: "/superAdmin/splash",
      },
      {
        id: "allPanics",
        title: "AllPanicAlerts",
        icon: AddToQueue,
        href: "/superAdmin/allPanics",
      },
      {
        id: "feedback",
        title: "Feedback",
        icon: Feedback,
        items: [
          {
            id: "sugerencias",
            title: "Sugerencias",
            icon: Feedback,
            href: "/superAdmin/sugerencias",
          },
          {
            id: "infoApp",
            title: "Info & Ayuda",
            icon: HelpOutline,
            href: "/superAdmin/infoApp",
          },
          {
            id: "faq",
            title: "FAQ",
            icon: QuestionAnswerIcon,
            href: "/superAdmin/FAQ",
          },
        ],
      },
      {
        id: "parametros",
        title: "Parametros - Botón de pagos ",
        icon: LocalAtmIcon,
        href: "/superAdmin/parametros",
      },
      {
        id: "historial",
        title: "Historial de consultas",
        icon: HistoryOutlined,
        href: "/superAdmin/historial",
      },
      {
        id: "actualizaciones",
        title: "Actualizaciones APP",
        icon: GetApp,
        href: "/superAdmin/actualizaciones",
      },
      {
        id: "cashbook",
        title: "Cashbook",
        icon: LocalAtmIcon,
        href: "/superAdmin/cashbook",
      },
    ],
  },
]
